import { Fragment, useEffect, useState } from "react";
import { CustomOverlayMap, Map, MapMarker, MapTypeControl } from "react-kakao-maps-sdk";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Request from "../commons/request";
import * as TypeDTO from "../commons/typeDTO";

import refreshIcon from "../assets/images/digitalKeyController/mapRefreshIcon.svg";

import { Space, Spin } from "antd";
import styles from "./RentCarsLocation.module.css";

declare const window: typeof globalThis & {
    webkit: any;
};

function RentCarsLocation() {
    const [kakaoMap, setKakaoMap] = useState<kakao.maps.Map | undefined>(undefined);
    const [rentCarsLocations, setRentCarsLocations] = useState<Array<TypeDTO.CarLocationDto>>();
    const [rentCarIds, setRentCarIds] = useState<Array<number>>();

    const handleMap = (map: kakao.maps.Map) => {
        setKakaoMap(map);
    };

    useEffect(() => {
        requestGetRentCars();
    }, []);

    useEffect(() => {
        if (!kakaoMap) return;
        requestGetRentCarsLocation();
    }, [kakaoMap]);

    const requestAxiosGetRentCarsLocation = async () => {
        console.log("requestAxiosGetRentCarsLocation");
        const response = await utilAxiosWithAuth().get(Request.RENT_CARS_LOCATION_URL);
        return response.data;
    };

    const {
        loading: loadingGetRentCarsLocation,
        error: errorGetRentCarsLocation,
        data: resultGetRentCarsLocation,
        execute: requestGetRentCarsLocation,
    } = useAsyncAxios(requestAxiosGetRentCarsLocation);

    useEffect(() => {
        if (resultGetRentCarsLocation === null || !rentCarIds) return;
        console.log("resultGetRentCarsLocation", resultGetRentCarsLocation);
        setRentCarsLocations(resultGetRentCarsLocation.rentCarsLocation.filter((item: TypeDTO.CarLocationDto) => rentCarIds.includes(item.fmsCarId)));
    }, [resultGetRentCarsLocation, rentCarIds]);

    useEffect(() => {
        if (errorGetRentCarsLocation === null) return;

        console.log("errorGetRentCarsLocation", errorGetRentCarsLocation);
    }, [errorGetRentCarsLocation]);

    useEffect(() => {
        if (!rentCarsLocations) return;

        const bounds = new kakao.maps.LatLngBounds();

        rentCarsLocations
            ?.filter((location) => location?.latitude && location?.longitude)
            ?.map((location) => {
                bounds.extend(new kakao.maps.LatLng(location.latitude, location.longitude));
            });

        kakaoMap?.setBounds(bounds);
    }, [rentCarsLocations]);

    const requestAxiosGetRentCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_CARS_URL);
        return response.data;
    };

    const {
        loading: loadingGetRentCars,
        error: errorGetRentCars,
        data: resultGetRentCars,
        execute: requestGetRentCars,
    } = useAsyncAxios(requestAxiosGetRentCars);

    useEffect(() => {
        if (!resultGetRentCars) return;
        console.log("resultGetRentCars", resultGetRentCars);

        setRentCarIds(
            resultGetRentCars.rentCars
                .filter((item: TypeDTO.RentCarDto) => item?.car?.carType?.typeId !== 3) // 렌트 사이트에서 typeId === 3은 준비중으로 표시하고 있음
                .map((item: TypeDTO.RentCarDto) => item.car.fmsCarId)
        );
    }, [resultGetRentCars]);

    useEffect(() => {
        if (!errorGetRentCars) return;
        console.log("errorGetRentCars", errorGetRentCars);
    }, [errorGetRentCars]);

    const handleRefreshBtnClick = () => {
        requestGetRentCarsLocation();
    };

    return (
        <section
            style={{
                position: "relative",
                width: "100vw",
                height: "calc(100vh - var(--header-height) - var(--footer-height))",
            }}
        >
            {(loadingGetRentCarsLocation || loadingGetRentCars) && (
                <div className={styles.loadingWrapper}>
                    <Space size={10} className={styles.loadingBox}>
                        <p className={styles.title}>LOADING...</p>
                        <p>차량 위치정보를 불러오는 중입니다</p>
                        <Spin className={styles.loadingSpin} />
                    </Space>
                </div>
            )}

            <Map
                center={{ lat: 35.817045, lng: 129.203335 }}
                onCreate={(map) => handleMap(map)}
                style={{ height: "calc(100vh - 75px)", width: "100%" }}
                level={4}
                isPanto={true}
            >
                <MapTypeControl position={kakao.maps.ControlPosition.TOPRIGHT} />
                {rentCarsLocations
                    ?.filter((location) => location?.latitude && location?.longitude)
                    ?.map((location) => (
                        <Fragment key={location.fmsCarId}>
                            <MapMarker
                                position={{
                                    lat: location.latitude,
                                    lng: location.longitude,
                                }}
                            />
                            <CustomOverlayMap position={{ lat: location.latitude, lng: location.longitude }} yAnchor={2.8}>
                                <div className={styles.carNumber}>{location.carNumber.slice(-4)}</div>
                            </CustomOverlayMap>
                        </Fragment>
                    ))}
            </Map>

            <div className={styles.mapBtnCircle} onClick={handleRefreshBtnClick}>
                <img src={refreshIcon} alt="refresh icon" height="20" />
            </div>
        </section>
    );
}

export default RentCarsLocation;
